import { EncryptStorage } from 'encrypt-storage';
import Cookies from 'js-cookie';

import { User } from 'models';

const {
  REACT_APP_ENCRYPT_KEY,
  REACT_APP_LOCAL_STORAGE_PREFIX,
  REACT_APP_NODE_ENV,
  REACT_APP_LOGISTICA_PREFIX,
} = process.env;

export const safeStorage = new EncryptStorage(REACT_APP_ENCRYPT_KEY, {
  prefix: REACT_APP_LOCAL_STORAGE_PREFIX || '@meritt:indicators',
});

if (REACT_APP_NODE_ENV !== 'production') {
  window.safeStorage = safeStorage;
}

/** COOKIES */
export function setLoggedUser(user: User): void {
  Cookies.set(`${REACT_APP_LOGISTICA_PREFIX}:loggedUser`, user);
}

export function getLoggedUser(): User | undefined {
  const user = Cookies.get(`${REACT_APP_LOGISTICA_PREFIX}:loggedUser`);

  return user ? JSON.parse(user) : undefined;
}

export function getUserToken(): string | undefined {
  const token = Cookies.get(`${REACT_APP_LOGISTICA_PREFIX}:accessToken`);

  return token || undefined;
}

export function removeLoggedUser(): void {
  Cookies.remove(`${REACT_APP_LOGISTICA_PREFIX}:loggedUser`);
}
